import {
  RegionWithState,
  State,
  Country,
  CountryWithStates,
  StoryWithFeaturedListing,
  Market,
} from '../restApi/types'

type PrehydratedHomePage = {
  country: Country
  states: State[]
  regions: RegionWithState[]
  stories: StoryWithFeaturedListing[]
  currentMarket: Market
  countries: CountryWithStates[]
  fulfillingMomentCount: number
}

export type HomePageState = {
  data: PrehydratedHomePage
}

export type HomePageRootState = {
  home: HomePageState
}

const initialState: HomePageState = {
  data: null,
}

type DetectedMarketFulfilled = {
  type: 'HOME_DETECTED_MARKET_FETCH_FULFILLED'
  payload: { data: PrehydratedHomePage | null }
}

/*
  During serverside rendering, data is placed in the redux store, under keys derived from reducer names.
*/
export default function reducer(
  state = initialState,
  action: DetectedMarketFulfilled | { type: string },
) {
  switch (action.type) {
    case 'HOME_DETECTED_MARKET_FETCH_FULFILLED': {
      const { payload } = action as DetectedMarketFulfilled
      // A null body means no market was detected — keep the neutral seed.
      if (!payload?.data?.currentMarket) return state

      return { ...state, data: payload.data }
    }
    default:
      return state
  }
}
